export enum PLACEMENTS {
  MAIN_PAGE = 'main_page',
  NEW = 'new',
  ACTIONS = 'actions',
  ALTERNATIVES = 'alternatives',
  LAST_VIEWS = 'last_views',
  BASKET = 'basket',
  PAGE_404 = '404_page',
}
